import { render, staticRenderFns } from "./policyList.vue?vue&type=template&id=19408f8c&scoped=true"
import script from "./policyList.vue?vue&type=script&lang=js"
export * from "./policyList.vue?vue&type=script&lang=js"
import style0 from "./policyList.vue?vue&type=style&index=0&id=19408f8c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19408f8c",
  null
  
)

export default component.exports